"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var mobx_1 = require("mobx");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var ScaleLegend_meta_1 = require("./ScaleLegend.meta");

var List_1 = require("../List/List");

var Scale_1 = require("../Scale/Scale");

var ScaleLegend =
/** @class */
function (_super) {
  __extends(ScaleLegend, _super);

  function ScaleLegend(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = ScaleLegend_meta_1.SCALE_LEGEND_CATEGORY_KEY;
    _this.componentKey = ScaleLegend_meta_1.SCALE_LEGEND_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(ScaleLegend.prototype, "listProps", {
    get: function get() {
      var _a = this.props,
          values = _a.values,
          heading = _a.heading,
          _b = _a.direction,
          direction = _b === void 0 ? 'DESC' : _b;
      var max = values.length;
      var items = values.map(function (value, idx) {
        var scaleProps = {
          max: max,
          value: idx + 1
        }; // The List component should translate the value

        return [react_1.default.createElement(Scale_1.Scale, __assign({}, scaleProps)), value];
      });

      if (direction === 'DESC') {
        items.reverse();
      }

      return {
        heading: heading,
        items: items,
        blankDataOptions: {
          placeholder: ''
        }
      };
    },
    enumerable: true,
    configurable: true
  });

  ScaleLegend.prototype.render = function () {
    var className = this.props.className;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      "aria-hidden": true
    }, react_1.default.createElement(List_1.List, __assign({}, this.listProps)));
  };

  __decorate([mobx_1.computed], ScaleLegend.prototype, "listProps", null);

  ScaleLegend = __decorate([mobx_react_1.observer], ScaleLegend);
  return ScaleLegend;
}(shared_1.ComponentBase);

exports.ScaleLegend = ScaleLegend;
exports.default = shared_1.InjectedStyledComponent(ScaleLegend, ScaleLegend_meta_1.SCALE_LEGEND_CATEGORY_KEY, ScaleLegend_meta_1.SCALE_LEGEND_COMPONENT_KEY);